
class StickyHeader {
    constructor() {
        this.header = document.getElementById("id-sub-header");
        if(this.header !== null) {
          // adding/removing logic added to fix sticky header glitch/snipping on scrolling.
          this.headerParent = this.header.parentElement;
          this.ghostHeader = document.createElement('div');
          this.ghostHeader.classList.add("site-sub-header");
          this.events();
        }
        window.Debug_Log("StickyHeader  >>>>>>>>>>>>>>>>>>>>>>>>>");
      }
    
      events() {        
        if(this.header !== null) {            
            this.headerYPos = this.header.offsetTop;            
            window.onscroll = (event) => this.onHeaderScroll(event);            
        }
      }
    
      onHeaderScroll(event) {
        console.log("onHeaderScroll");
        if(this.header !== null) { 
          if(window.pageYOffset > this.headerYPos) {            
              if(this.headerParent !== null)
              {
                this.headerParent.insertBefore(this.ghostHeader, this.header);
                //this.headerParent.appendChild(this.ghostHeader);
              }
              this.header.classList.add("site-sub-header_sticky");
          } else {
              this.header.classList.remove("site-sub-header_sticky");
              if(this.headerParent !== null)
              {
                if(this.headerParent.contains(this.ghostHeader)) {
                  this.headerParent.removeChild(this.ghostHeader);
                }
              }
          }
        }
      }    
}

export default StickyHeader;